/**
 * This function validates a record ID passed in by the user to
 * make sure it's a valid integer within the range of the Postgres
 * INTEGER type.
 */

import parseQueryNumber from '@/utils/parseQueryNumber'

const MAX_POSTGRES_INTEGER = 2147483647

export default function parseRecordId(
  number: string | string[] | number | undefined
): number | null {
  const parsed = parseQueryNumber({ value: number, defaultValue: 0 })

  if (parsed < 1 || parsed > MAX_POSTGRES_INTEGER) {
    return null
  }

  return parsed
}
